import React from 'react';
import { createRoot } from 'react-dom/client';
import { Icon } from '@ok/okd';
import './ShowBigImg.less';
/**
 * 显示大图
 * imgClassName: 采用背景图方式
 * when: 显示条件
 * onClick: 点击回调
 *
 * fixme 最开始由于没有图片服务器，图片放在工程内，最终会放到cdn上 直接img在页面引用会找不到的问题
 */
export function ShowBigImg({ imgClassName, when, onClick }) {
  return (
    <div
      className={`show-big-img-container ${when ? '' : 'hide'}`}
      onClick={onClick}
    >
      <Icon className="okds-close" />
      <div className="show-big-img-bg" />
      <div className={`${imgClassName} big-img`} />
    </div>
  );
}
/**
 * 显示大图
 * url: 图片地址
 * visible: 显示条件
 * onClose: 点击关闭
 *
 */
export function ShowLargeImg({ url, visible, onClose }) {
  let comp = null;
  if (visible) {
    comp = (
      <div className="show-big-img-container large-container" onClick={onClose}>
        <Icon className="okds-close" />
        <div className="show-big-img-bg" />
        <img className="img" src={url} alt="" />
      </div>
    );
  }
  return comp;
}
function create(config) {
  const div = document.createElement('div');
  document.body.appendChild(div);
  const root = createRoot(div);
  function destroy() {
    root.unmount();
    if (div.parentNode) {
      div.parentNode.removeChild(div);
    }
  }
  function close() {
    destroy();
    if (config.onClose) {
      config.onClose();
    }
  }
  let currentConfig = {
    ...config,
    visible: true,
    onClose: close,
  };
  function render(props) {
    root.render(<ShowLargeImg {...props} />);
  }
  function update(newConfig) {
    currentConfig = {
      ...currentConfig,
      ...newConfig,
    };
    render(currentConfig);
  }
  render(currentConfig);
  return {
    destroy,
    update,
  };
}
ShowLargeImg.show = create;
